import React from 'react';
import { Skeleton } from '@mui/material';

/**
 * Loading skeleton for dashboard components
 * Provides better UX than a full-page loader
 */

export function StatCardSkeleton() {
  return (
    <div className="px-4 py-4 flex items-center justify-start gap-3 rounded-[14px] bg-gray-200 animate-pulse">
      <Skeleton variant="circular" width={40} height={40} />
      <div className="flex flex-col gap-1">
        <Skeleton variant="text" width={100} height={20} />
        <Skeleton variant="text" width={60} height={28} />
      </div>
    </div>
  );
}

export function StatsGridSkeleton() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-9 px-4 sm:px-9 gap-2 sm:gap-7">
      <StatCardSkeleton />
      <StatCardSkeleton />
      <StatCardSkeleton />
    </div>
  );
}

export function DiscountSectionSkeleton() {
  return (
    <div className="mt-12 px-9">
      <Skeleton variant="text" width={200} height={24} />
      <Skeleton variant="text" width={80} height={20} className="mt-1" />
    </div>
  );
}

export function MonthlyTableSkeleton() {
  return (
    <div className="mt-6 px-9">
      <Skeleton variant="text" width={220} height={24} />
      <Skeleton variant="text" width={100} height={18} className="mt-1" />
      <div className="mt-4">
        <Skeleton variant="rectangular" width="100%" height={80} className="rounded" />
      </div>
    </div>
  );
}

export function GraphSkeleton() {
  return (
    <div className="mt-8 px-9">
      <Skeleton variant="rectangular" width="100%" height={400} className="rounded-lg" />
    </div>
  );
}

export default function DashboardSkeleton() {
  return (
    <div className="animate-pulse">
      <StatsGridSkeleton />
      <DiscountSectionSkeleton />
      <div className="mt-6 px-9">
        <Skeleton variant="text" width={180} height={24} />
        <Skeleton variant="text" width={140} height={20} className="mt-2" />
        <Skeleton variant="text" width={160} height={18} className="mt-1" />
        <Skeleton variant="text" width={160} height={18} className="mt-1" />
      </div>
      <MonthlyTableSkeleton />
      <GraphSkeleton />
    </div>
  );
}
